// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgLabel = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.75 6.75v10.5h12.849l3.5-5.25-3.5-5.25zm-1.5-.15c0-.746.604-1.35 1.35-1.35h13.079c.451 0 .873.226 1.123.601l3.6 5.4a1.35 1.35 0 0 1 0 1.498l-3.6 5.4a1.35 1.35 0 0 1-1.123.601H3.6a1.35 1.35 0 0 1-1.35-1.35z"
      clipRule="evenodd"
    />
  </svg>
);
export const LabelIcon = forwardRef(SvgLabel);
